<!-- eslint-disable vue/no-parsing-error -->
<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<template>
  <div class="photo-list">
    <div
      v-for="photo in photoList"
      :key="photo.index"
      class="photo-item"
      @click="showPhoto(photo.index)"
    >
      <picture>
        <source v-if="photo.md"
          :srcset="$store.getters.apiDomain + photo.md" media="(min-width: 576px)">
        <source v-if="photo.lg"
          :srcset="$store.getters.apiDomain + photo.lg" media="(min-width: 992px)">
        <source v-if="photo.xl"
          :srcset="$store.getters.apiDomain + photo.xl" media="(min-width: 1200px)">
        <source v-if="photo.xxl"
          :srcset="$store.getters.apiDomain + photo.xl" media="(min-width: 1400px)">
        <img :src="$store.getters.apiDomain + photo.preview" alt="">
      </picture>
    </div>
  </div>
  <div v-if="currentPhotoIndex != null" class="photo-view__wrapper">
    <button @click="closeGalleryView" class="photo-btn photo-btn-close">
      <i class="exu-x-close"></i>
    </button>
    <button @click="prevGalleryView" class="photo-btn photo-btn-prev">
      <i class="exu-chevron-left"></i>
    </button>
    <button @click="nextGalleryView" class="photo-btn photo-btn-next">
      <i class="exu-chevron-right"></i>
    </button>
    <div class="photo-view">
      <picture>
        <source v-if="curentPhoto.md"
          :srcset="$store.getters.apiDomain + curentPhoto.md" media="(min-width: 576px)">
        <source v-if="curentPhoto.lg"
          :srcset="$store.getters.apiDomain + curentPhoto.lg" media="(min-width: 768px)">
        <source v-if="curentPhoto.xl"
          :srcset="$store.getters.apiDomain + curentPhoto.xl" media="(min-width: 992px)">
        <source v-if="curentPhoto.xxl"
          :srcset="$store.getters.apiDomain + curentPhoto.xxl" media="(min-width: 1200px)">
        <img
          :src="$store.getters.apiDomain + curentPhoto.md"
          alt=""
          :class="{'hidden': !photoView}"
        >
      </picture>
    </div>
  </div>
</template>

<script>
import appBaseNav from '@/components/mixins/appBaseNav';
import apiGallery from '@/components/mixins/api/apiMethodsGallery';

export default {
  name: 'GalleryView',
  data() {
    return {
      photoList: [],
      currentPhotoIndex: null,
      photoView: true,
    };
  },
  mixins: [appBaseNav, apiGallery],
  watch: {
    locale() {
      this.$store.commit('setPageTitle', this.$t('gallery.header_title'));
    },
  },
  computed: {
    curentPhoto() {
      return this.currentPhotoIndex !== null ? this.photoList[this.currentPhotoIndex] : null;
    },
  },
  mounted() {
    this.$store.commit('setPageTitle', this.$t('gallery.header_title'));
    this.getPage();
  },
  methods: {
    getPage() {
      this.getGallery()
        .then((data) => {
          console.log(data);
          if (data.images && data.images.length > 0) {
            this.photoList = data.images.map((item, index) => {
              const photo = { ...item };
              photo.index = index;
              return photo;
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    showPhoto(index) {
      this.currentPhotoIndex = index;
      console.log(index);
    },
    closeGalleryView() {
      this.currentPhotoIndex = null;
    },
    prevGalleryView() {
      this.photoView = false;
      setTimeout(() => {
        this.currentPhotoIndex -= 1;
        this.currentPhotoIndex = this.currentPhotoIndex >= 0
          ? this.currentPhotoIndex : this.photoList.length - 1;
        this.photoView = true;
      }, 250);
    },
    nextGalleryView() {
      this.photoView = false;
      setTimeout(() => {
        this.currentPhotoIndex += 1;
        this.currentPhotoIndex = this.currentPhotoIndex < this.photoList.length
          ? this.currentPhotoIndex : 0;
        this.photoView = true;
      }, 250);
    },
  },
};
</script>

<style lang="scss">
.photo-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  max-width: 760px;
  gap: 12px;
  padding: 6px;
  margin: 0 auto;
}
.photo-item {
  flex: 0 1 calc(50% - 6px);
  overflow: hidden;

  &:first-child {
    border-top-left-radius: 16px;
  }
  &:nth-child(2) {
    border-top-right-radius: 16px;
  }
  &:nth-last-child(2) {
    border-bottom-left-radius: 16px;
  }
  &:last-child {
    border-bottom-right-radius: 16px;
  }

  img {
    max-width: 100%;
  }
}
.photo-view {
  grid-column-start: photo-start;
  grid-column-end: photo-end;
  grid-row-start: photo-start;
  grid-row-end: photo-end;
  z-index: 100;

  display: flex;
  align-items: center;
  justify-content: center;

  &__wrapper {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    display: grid;
    grid-template-columns:
      [start] 3px
      [photo-start] 3px
      [left-btn-start] 40px
      [left-btn-end] 1fr
      [right-btn-start] 40px
      [right-btn-end] 3px
      [photo-end] 3px
      [end];
    grid-template-rows:
      [start] 3px
      [photo-start] 3px
      [close-btn-start] 40px
      [close-btn-end] 1fr
      [middle-btn-start] 40px
      [middle-btn-end] 1fr
      [end];
    background: rgba(16,16,16,.95);
    z-index: 1000;

    .photo-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      background-color: transparent;
      border: none;
      z-index: 200;
      color: #e0e0e0;
      font-size: 24px;
      background-color: rgba(16,16,16,.5);
      border-radius: 8px;
    }
    .photo-btn-close {
      grid-column-start: right-btn-start;
      grid-column-end: right-btn-end;
      grid-row-start: close-btn-start;
      grid-row-end: close-btn-end;
    }
    .photo-btn-prev {
      grid-column-start: left-btn-start;
      grid-column-end: left-btn-end;
      grid-row-start: middle-btn-start;
      grid-row-end: middle-btn-end;
    }
    .photo-btn-next {
      grid-column-start: right-btn-start;
      grid-column-end: right-btn-end;
      grid-row-start: middle-btn-start;
      grid-row-end: middle-btn-end;
    }
  }

  picture {
    display: flex;
    min-height: 90vh;
    height: 100%;
    width: 100%;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
  }

  img {
    max-width: 100%;
    max-height: 100%;
    opacity: 1;
    transition-property: opacity;
    transition-duration: .25s;
    transition-timing-function: ease-in-out;

    &.hidden {
      opacity: 0;
    }
  }
}
</style>
